import { Component, ViewEncapsulation, SimpleChanges } from '@angular/core';

import { VraagboomEmptyResultaat } from '@models/vragenboom';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { Vraag, Antwoord } from '@models/claims';
import { Router } from '@angular/router';
import { DataService } from '../../../services/data.service';
import { MetenMapper } from '../../../mappers/meten.mapper';

@Component({
  selector: 'app-button-succes',
  templateUrl: './button-succes.component.html',
  styleUrls: ['./button-succes.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonSuccesComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> {

  constructor(
    private router: Router,
    _dataService: DataService) {
    super(_dataService);
  }

  initialize(changes: SimpleChanges): void { }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    return true;
  }

  successButtonClicked(): void {
    if (this.vraag && this.vraag.button_link) {
      if (this.vraag.button_link.startsWith('https://') || this.vraag.button_link.startsWith('http://')) {
        window.open(this.vraag.button_link, '_blank');
      } else {
        this.router.navigate(['/externalRedirect', { externalUrl: this.vraag.button_link }]);
      }
    } else {
      this.setAntwoord(this.vraag.antwoorden, new VraagboomEmptyResultaat());
    }
  }

  geefMeetid(titel: string): string {
    return `ipoclick-btn-success-${this._dataService.getMeetidPazaProces()}-${MetenMapper.format(titel)}`;
  }
}
